let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aqaJT")).then(() => parcelRequire('7QGw8'));